import {useQuery} from 'react-query'
import {deleteTripNumber, fetchTripNumberList} from './api'
import {PageTitle} from '../../../_metronic/layout/core'
import {Error500} from '../../modules/errors/components/Error500'
import CRUDTable from '../../../components/table/CRUDTable'
import toast, {Toaster} from 'react-hot-toast'
import DeleteButton from '../../../components/DeleteButton'
import ModalWithForm from '../../../components/ModalWithForm'
import EditBtn from '../../../components/EditBtn'
import {Button} from 'react-bootstrap'
import viewProps from '../viewProps'
import {Processing} from '../../../components/Loaders'
import {Helmet} from 'react-helmet'
import TripNumberForm from './Form'
import ActivePill from '../../../components/ActivePill'
import InactivePill from '../../../components/InactivePill'
import PortalDropdown from '../../../components/PortalDropdown'
import DeleteConfirmationModal from '../../../components/DeleteWarning'
import EditLabel from '../../../components/EditLabel'
import DeleteLabel from '../../../components/DeleteLabel'
import TopBarProgress from 'react-topbar-progress-indicator'

const tripNumberBreadcrumbs = [
  {
    title: 'School Management',
    path: 'school-management/all-trip-numbers',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

function TripNumber() {
  const {data, isError, isFetching, isLoading, refetch} = useQuery(
    'tripNumberList',
    fetchTripNumberList,
    {
      refetchOnWindowFocus: false,
    }
  )

  if (isLoading) {
    return <Processing />
  }
  const cellModifier = {
    trip_number_status: ({value}) => {
      switch (Number(value)) {
        case 1:
          return <ActivePill />
        case 0:
          return <InactivePill />
        default:
          return ''
      }
    },
    Actions: ({row}) => {
      return (
        <PortalDropdown triggerProps={{className: 'btn btn-secondary px-0 py-1'}}>
          <span className="dropdown-item p-0">
            <ModalWithForm
              modalTitle={'Update Trip Number'}
              initialValues={row.original}
              onSubmit={refetch}
              Form={TripNumberForm}
              modalAttrs={{size: 'sm'}}
              triggerClassName="d-block"
            >
              <EditLabel />
            </ModalWithForm>
          </span>
          <span className="dropdown-item p-0">
            <DeleteConfirmationModal
              triggerClassName="d-block"
              onDelete={async () => {
                const toastId = toast.loading('Deleting Please wait...')
                try {
                  const response = await deleteTripNumber(row.original.trip_number_id)
                  if (response?.status === false && response?.message) {
                    toast.error(response.message, {id: toastId})
                    return null
                  }
                  await refetch()
                  toast.success('Deleted Successfully', {id: toastId})
                } catch (error) {
                  toast.error('Something went wrong, please try again later', {id: toastId})
                }
              }}
            >
              <DeleteLabel />
            </DeleteConfirmationModal>
          </span>
        </PortalDropdown>
      )
    },
  }

  return (
    <>
      <Helmet>
        <title>TrackNAB | Trip Number list</title>
      </Helmet>
      <PageTitle breadcrumbs={tripNumberBreadcrumbs}>Trip Number</PageTitle>
      {isError ? (
        <div className="text-center">
          <Error500 />
        </div>
      ) : (
        <CRUDTable
          data={data?.data || []}
          {...viewProps.Bus}
          fieldToLabelMap={viewProps.TripNumber.primaryFieldsToLabelMap}
          Form={TripNumberForm}
          formSize={{size: 'md'}}
          cellModifier={cellModifier}
          nonSortableColumns={['Actions']}
          headerExtras={
            <ModalWithForm
              modalTitle={'Add Trip Number'}
              triggerClassName="ms-auto"
              onSubmit={refetch}
              Form={TripNumberForm}
              modalAttrs={{size: 'sm'}}
            >
              <Button size="sm">Add Trip Number</Button>
            </ModalWithForm>
          }
        />
      )}
      {isFetching && <TopBarProgress />}

      <Toaster />
    </>
  )
}

export default TripNumber
